module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic4.892578d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic4.png
// module id = 570
// module chunks = 1